// Cross-host login constants (reCAPTCHA key, plan/app-icon base URLs, the resend
// endpoint, the intro-animation session key) live in @ow/shared/login/constants
// so the website and the ow-app in-app login share one source of truth.
export {
  kRecaptchaWidgetId,
  kPlanBaseUrl,
  kAppIconBaseUrl,
  kResendVerificationEndpoint,
  kSawAnimationKey,
} from '@ow/shared/login/constants';

// Website-only login constants: the web social-login redirect flow and the
// post-login session keys the store uses to resume a download / review.
export const kSocialLoginEndpoint = 'https://accounts.overwolf.com/web/auth/';
export const kLoginRedirectParam = 'callbackRedirectUrl';
export const kSocialCallbackParam = 'socialLoginCallback';
export const kSocialNetworkParam = 'SocialNetwork';

export const kPostLoginAppKey = 'postLoginDownloadApp';
export const kPostLoginReviewKey = 'postLoginReview';
export const kPostLoginOverrideUrlKey = 'postLoginOverrideUrl';

export const kRestoreAccountEndpoint =
  'https://accounts.overwolf.com/privacy/control?action=cancel-account-deletion';
